import domtoimage from 'dom-to-image';
import { jsPDF } from 'jspdf';

/**
 * Genera un PDF a partir de un elemento DOM
 * @param {HTMLElement} element - El elemento DOM a convertir en PDF
 * @param {string} fileName - Nombre del archivo PDF (sin extensión)
 * @returns {Promise<void>}
 */
export const generatePdfFromElement = async (element, fileName) => {
    try {
        // Mostrar temporalmente el elemento
        element.style.display = "block";
        
        // Eliminar todas las restricciones de ancho temporalmente
        const originalStyles = {
            width: element.style.width,
            minWidth: element.style.minWidth,
            maxWidth: element.style.maxWidth,
            overflow: element.style.overflow
        };
        
        // Permitir que el elemento se expanda libremente
        element.style.width = 'auto';
        element.style.minWidth = 'auto';
        element.style.maxWidth = 'none';
        element.style.overflow = 'visible';
        
        // Esperar a que se apliquen los cambios
        await new Promise(resolve => setTimeout(resolve, 200));
        
        // Capturar el elemento con su ancho natural
        const imgData = await domtoimage.toPng(element, {
            quality: 1.0,
            bgcolor: '#ffffff',
            style: {
                'transform': 'scale(1.0)',
                'transform-origin': 'top left'
            },
            width: element.scrollWidth,
            height: element.scrollHeight,
            imagePlaceholder: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
        });
        
        // Restaurar los estilos originales
        element.style.width = originalStyles.width;
        element.style.minWidth = originalStyles.minWidth;
        element.style.maxWidth = originalStyles.maxWidth;
        element.style.overflow = originalStyles.overflow;
        
        // Crear PDF con las dimensiones de la imagen
        const img = new Image();
        img.src = imgData;
        
        await new Promise((resolve) => {
            img.onload = () => {
                // Añadir márgenes muy generosos
                const margin = 100; // 100px de margen en cada lado
                const pdfWidth = img.width + (margin * 2);
                const pdfHeight = img.height + (margin * 2);
                
                // Asegurar un tamaño mínimo muy amplio
                const finalWidth = Math.max(pdfWidth, 1400);
                const finalHeight = Math.max(pdfHeight, 900);
                
                const pdf = new jsPDF({
                    orientation: finalWidth > finalHeight ? 'landscape' : 'portrait',
                    unit: 'px',
                    format: [finalWidth, finalHeight]
                });
                
                // Centrar la imagen en el PDF
                const xOffset = (finalWidth - img.width) / 2;
                const yOffset = (finalHeight - img.height) / 2;
                
                // Añadir la imagen centrada
                pdf.addImage(imgData, 'PNG', xOffset, yOffset, img.width, img.height, undefined, 'FAST');
                pdf.save(fileName + `-SimulaRCP.pdf`);
                resolve();
            };
        });
        
        // Ocultar el elemento nuevamente
        element.style.display = "none";
    } catch (error) {
        console.error('Error generando PDF:', error);
        throw error;
    }
}; 